import { Logo } from "./Logo";
import { SITE, NAV, scrollToId } from "@/lib/site";
import { openCookieSettings } from "@/lib/consent";

const link = "hover:text-[#e8c063] transition-colors";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#0d0d0e] border-t border-[#d4a73c]/15 pt-20 pb-28 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-6 text-sm text-[#c9c3b7] leading-relaxed max-w-xs">
            Ristrutturazioni chiavi in mano a Roma e dintorni. Un unico interlocutore, dalla demolizione alle chiavi.
          </p>
        </div>
        <div className="md:col-span-3 text-sm text-[#c9c3b7] space-y-2">
          <p className="label mb-4">Sede</p>
          <p>{SITE.address}</p>
          <p>{SITE.city}</p>
          <a href={SITE.phoneHref} data-testid="footer-phone" className="block hover:text-[#e8c063]">{SITE.phone}</a>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="block hover:text-[#e8c063] break-all">{SITE.email}</a>
        </div>
        <div className="md:col-span-2 text-sm text-[#c9c3b7] space-y-2">
          <p className="label mb-4">Orari</p>
          {SITE.hours.map(([d, h]) => <p key={d}>{d}<br /><span className="text-[#f4f1ea]">{h}</span></p>)}
        </div>
        <div className="md:col-span-3 text-sm space-y-2">
          <p className="label mb-4">Sezioni</p>
          {NAV.map(([l, id]) => (
            <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="block text-[#c9c3b7] hover:text-[#e8c063]">{l}</button>
          ))}
        </div>
      </div>
      <p className="mt-20 font-display font-light text-[17vw] md:text-[12vw] leading-[0.85] text-[#d4a73c]/15 select-none whitespace-nowrap">Slusariuc</p>
      <div data-testid="footer-legal" className="mt-8 border-t border-[#d4a73c]/15 pt-8 grid md:grid-cols-12 gap-6 text-xs text-[#bdb7ab] leading-relaxed">
        <div className="md:col-span-8 space-y-1">
          <p className="text-[#f4f1ea]">Slusariuc Costruzioni</p>
          <p data-testid="footer-address">Sede: {SITE.address}, {SITE.city}</p>
          <p data-testid="footer-vat">P.IVA {SITE.vat} · C.F. {SITE.cf} · REA {SITE.rea}</p>
          <p data-testid="footer-copyright">© 2026 Slusariuc Costruzioni. Tutti i diritti riservati.</p>
        </div>
        <nav className="md:col-span-4 flex flex-wrap md:flex-col md:items-end gap-x-6 gap-y-2">
          <a href="/privacy-policy" data-testid="footer-privacy-link" className={link}>Privacy Policy</a>
          <a href="/cookie-policy" data-testid="footer-cookie-link" className={link}>Cookie Policy</a>
          <button onClick={openCookieSettings} data-testid="footer-cookie-settings" className={link}>Gestisci cookie</button>
          <a href="/admin" data-testid="footer-admin-link" className={link}>Area riservata</a>
        </nav>
      </div>
    </div>
  </footer>
);
